import router from "@/router"
import httpRequest from "@/services/httpRequest"
import { dbService } from "@/services/dbService"

export default ({
  namespaced: true,
  state: {
    page: 1,
    rows: 20,
    search: '',
    searchMember: '',
    filter: '',
    examList: [],
    isLoading: true,
    examDetail: null,
    errorToken: null,
    questions: [],
    questionsAnswer: [],
    currentQuestionId: null,
    currentQuestionIndex: null,
    examDetailInExamination: null,
    totalFoul: 1,
    questionCollectionList: [],
    questionCollection: {},
    classrooms: [],
    students: [],
    examMembers: [],
    examSummary: null,
    essayList: [],
    studentAnswers: null
  },
  mutations: {
    SET_EXAM_LIST_FIRST(state, data) {
      state.examList = data
      state.isLoading = false
    },
    SET_EXAM_LIST(state, data) {
      data.forEach((item) => {
        state.examList.push(item)
      })
    },
    SET_EXAM(state, data) {
      state.examDetail = data
    },
    SET_QUESTION_LIST(state, data) {
      data.questions.forEach((item, index) => {
        item.number = index + 1
      })
      state.currentQuestionIndex = data.exam.current_question || 1
      state.questions = data.questions
      state.questionsAnswer = data.questions_answer
      state.currentQuestionId = data.current_question_id
      state.examDetailInExamination = data.exam
      router.replace({ path: '/academic-exam' })
      state.isLoading = false
    },
    SET_TOTAL_FOUL(state, data) {
      state.totalFoul = data.foul
    },

    SET_QUESTION_COLLECTION_FIRST(state, data) {
      state.questionCollectionList = data
      state.isLoading = false
    },
    SET_QUESTION_COLLECTION(state, data) {
      data.forEach((item) => {
        state.questionCollectionList.push(item)
      })
      state.isLoading = false
    },
    SET_QUESTION_COLLECTION_PACKAGE(state, data) {
      state.questionCollection = data
      state.isLoading = false
    },
    SET_CLASSROOM_FIRST(state, data) {
      state.classrooms = data
      state.isLoading = false
    },
    SET_CLASSROOM(state, data) {
      data.forEach((item) => {
        state.classrooms.push(item)
      })
      state.isLoading = false
    },
    SET_STUDENT_FIRST(state, data) {
      state.students = data
      state.isLoading = false
    },
    SET_STUDENT(state, data) {
      data.forEach((item) => {
        state.students.push(item)
      })
      state.isLoading = false
    },
    SET_EXAM_MEMBER_FIRST(state, data) {
      state.examMembers = data
      state.isLoading = false
    },
    SET_EXAM_MEMBER(state, data) {
      data.forEach((item) => {
        state.examMembers.push(item)
      })
      state.isLoading = false
    },
    SET_EXAM_SUMMARY(state, data) {
      state.examSummary = data
    },

    SET_ESSAY_LIST(state, data) {
      state.essayList = data
    },

    SET_STUDENT_ANSWER(state, data) {
      let answers = Object.values(data)
      let mc = []
      let essay = []
      let matching = []
      answers.forEach((item) => {
        if (item.question_type === 'mc') {
          mc.push(item)
        }
        if (item.question_type === 'essay') {
          essay.push(item)
        }
        if (item.question_type === 'matchings') {
          matching.push(item)
        }
      })
    
      state.studentAnswers = {mc: mc, essay: essay, matching: matching}
      state.isLoading = false
    }
  },
  getters: {
    getMultipleChoiceQuestions: (state) => {
      return state.questions.filter((item) => item.question_type === 'mc')
    },
    getEssayQuestions: (state) => {
      return state.questions.filter((item) => item.question_type === 'essay')
    },
    getMatchingQuestions: (state) => {
      return state.questions.filter((item) => item.question_type === 'matchings')
    },
  },
  actions: {
    async getStudentExamList({ rootState, commit, state }, status) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studentexamination?page=${state.page}&rows=${state.rows}&search=${state.search}${state.filter}`,
          method: 'GET',
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        //console.log('response = ', res.data.results)
        if (status === 'first') {
          commit('SET_EXAM_LIST_FIRST', res.data.results)
        } else {
          commit('SET_EXAM_LIST', res.data.results)
        }
      } else {
        //console.log('getPaymentHistory res = ', res)
      }
    },

    async getTeacherExamList({ rootState, commit, state }, status) {
      const query = '{id,name,question_collection,duration,start_at,close_at,status,allow_login,student_number,student_logged_in_number}'

      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/examination?page=${state.page}&rows=${state.rows}&search=${state.search}&query=${query}${state.filter}`,
          method: 'GET',
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        //console.log('response = ', res.data.results)
        if (status === 'first') {
          commit('SET_EXAM_LIST_FIRST', res.data.results)
        } else {
          commit('SET_EXAM_LIST', res.data.results)
        }
      } else {
        //console.log('getPaymentHistory res = ', res)
      }
    },

    async getExam({ rootState, commit, state }, data) {
      //console.log('get exam = ', data)
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/${data.role === 'student' ? 'studentexamination' : 'examination'}/${data.id}`,
          method: 'GET',
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        commit('SET_EXAM', res.data)
        state.isLoading = false
      }
    },

    async getExamSummary({rootState, commit, state}, data) {
      //console.log('get exam = ', data)
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/examination/${data.id}/summary`,
          method: 'GET',
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        commit('SET_EXAM_SUMMARY', res.data)
        state.isLoading = false
      }
    },

    async loginExam({ rootState, commit, state }, data) {
      state.errorToken = null
      let payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studentexamination/${data.examId}/begin_exam_v2`,
          method: 'POST',
          data: {
            token: data.token
          }
        },
        authorized: true
      }

      // jika sudah login
      const isLogin = rootState.exam.examDetail?.login_count > 0 
      const isReset = rootState.exam.examDetail?.login_count === 0
      // console.log('isLogin = ', isLogin)
      // console.log('isReset = ', isReset)
      
      if (isReset) {
        // console.log('reset = ', rootState.exam.examDetail?.id)
        await dbService.deleteExam(rootState.exam.examDetail?.id)
      }

      // Cek Data Lokal
      const localData = await dbService.getExam(data.examId);

      if (localData && !isReset) {
        //console.log('sudah login dan ada data lokal')
        const res = await httpRequest(payload)
        if (res.status === 200) {
          commit('SET_QUESTION_LIST', localData) // Load data dari SQLite ke State
        } else {
          state.errorToken = 'Token tidak sesuai'
        }
      } else if (!localData && isLogin) {
        //console.log('sudah login tapi data lokal kosong')
        payload.options.data = { token: data.token, refetch: true}
        const res = await httpRequest(payload)
        if (res.status === 200) {
          await dbService.saveExam(data.examId, res.data); 
          commit('SET_QUESTION_LIST', res.data);
        } else {
          state.errorToken = 'Token tidak sesuai'
        }
      } else {
        const res = await httpRequest(payload)
        //console.log('ambil baru')
        if (res.status === 200) {
          await dbService.saveExam(data.examId, res.data); 
          commit('SET_QUESTION_LIST', res.data);
        } else {
          state.errorToken = 'Token tidak sesuai'
        }
      }

      
      rootState.isLoading = false
    },

    async updateExam({ rootState, commit, state }, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studentexamination/${data.examId}`,
          method: 'PUT',
          data: data.data
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        //console.log(res)
        state.isLoading = false
      } else {
        //console.log(res)
      }
    },
    
    async updateExamMember({ rootState, commit, state }, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studentexamination`,
          method: 'POST',
          data: data
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        return true
      } else {
        return false
      }
    },

    async doExam({ commit, rootState, state }, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studentexamination/${state.examDetailInExamination.id}/do`,
          method: 'POST',
          data: data
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        if (data.action === 'foul') {
          commit('SET_TOTAL_FOUL', res.data)
        }
        rootState.isLoading = false
        state.isLoading = false
        if (data.finish) {
          rootState.showPopUpModal = true
        }
        return true
      } else {
        state.isLoading = false
        if (res.status === 403) {
          return false
        }
      }
    },

    async getQuestionCollection({ rootState, commit, state }, type) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/questioncollection?page=${state.page}&rows=${state.rows}&search=${state.search}`,
          method: 'GET'
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        if (type === 'first') {
          //console.log('first = ', res.data.results)
          commit('SET_QUESTION_COLLECTION_FIRST', res.data.results)
        } else {
          commit('SET_QUESTION_COLLECTION', res.data.results)
        }
      }
    },

    async getQuestionCollectionPackage({ rootState, commit, state }, id) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/questioncollection/${id}`,
          method: 'GET'
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        commit('SET_QUESTION_COLLECTION_PACKAGE', res.data)
      }
    },

    async createExam({ rootState }, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/examination`,
          method: 'POST',
          data: data
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 201) {
        rootState.showPopUpModal = true
        rootState.isLoading = false
      } else {
        //console.log(res)
        rootState.isLoading = false
      }
    },
    
    async updateExamTeacher({ rootState, state, commit }, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/examination/${data.id}`,
          method: 'PATCH',
          data: data.data
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        commit('SET_EXAM', res.data)
        return res
      } else {
        //console.log(res)
      }
    },

    async getClassroom({ rootState, state, commit }, status) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/classroom?level__isnull=false&page=${state.page}&rows=100&search=${state.search}`,
          method: 'GET'
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        if (status === 'first') {
          commit('SET_CLASSROOM_FIRST', res.data.results)
        } else {
          commit('SET_CLASSROOM', res.data.results)
        }
      }
    },
    
    async getStudent({ rootState, state, commit }, status) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/student?query={id,name,photo,classroom}&page=${state.page}&rows=${state.rows}&search=${state.search}`,
          method: 'GET'
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        if (status === 'first') {
          commit('SET_STUDENT_FIRST', res.data.results)
        } else {
          commit('SET_STUDENT', res.data.results)
        }
      }
    },

    async doExamTeacher({ commit, rootState, state }, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studentexamination/${data.idExam}/teacher_do`,
          method: 'POST',
          data: data.data
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        return true
      } else {
        return false
      }
    },
    
    async examTeacherDo({ commit, rootState, state }, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/examination/${data.idExam}/teacher_do`,
          method: 'POST',
          data: data.data
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        if (data.data.action === 'get_student_essays') {
          commit('SET_ESSAY_LIST', res.data)
        }
        rootState.isLoading = false
        state.isLoading = false
        return true
      } else {
        rootState.isLoading = false
        state.isLoading = false
        return false
      }
    },

    async getExamMember({commit, rootState, state}, data) {
      let params = ''
      if (data.params) {
        params = `&${data.params}`
      }
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studentexamination?examination=${data.examId}${params}&page=${state.page}&rows=${state.rows}&search=${state.searchMember}`,
          method: 'GET'
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        if (data.status === 'first') {
          commit('SET_EXAM_MEMBER_FIRST', res.data.results)
        } else {
          commit('SET_EXAM_MEMBER', res.data.results)
        }
        
      } else {
      }
    },

    async getExamMemberLive({commit, rootState, state}, data) {
      if (data.params) {
        params = `&${data.params}`
      }
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studentexamination?examination=${data.examId}&rows=${state.rows * state.page}&search=${state.searchMember}`,
          method: 'GET'
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        commit('SET_EXAM_MEMBER_FIRST', res.data.results)
      } else {
      }
    },

    async removeExamMember({rootState}, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studentexamination/${data}`,
          method: 'DELETE'
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 204) {
       return true
      } else {
        return false
      }
    },

    async getStudentAnswer({rootState, commit, state}, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studentexamination/${data}/review`,
          method: 'GET'
        },
        authorized: true
      }

      const res = await httpRequest(payload)
      
      if (res.status === 200) {
        commit('SET_STUDENT_ANSWER', res.data)
      } else {
        state.isLoading = false
      }
    },
    
    async uploadAnswerImage({rootState, }, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studentexamination/${data.id}/upload_essay_answer_image`,
          method: 'POST',
          data: data.data
        },
        authorized: true
      }
  
      const res = await httpRequest(payload)

      if (res.status === 200) {
        //console.log(res)
        return res
      } else {
        return false
      }

    },

    async deleteExam({ rootState, state, commit }, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/examination/${data.id}`,
          method: 'DELETE'
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      return res
    },

    async getReportExam({ rootState }, id) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/examination/${id}/get_score_report`,
          method: 'GET'
        },
        authorized: true,
        isDownload: true,

      }

      const res = await httpRequest(payload)
      //console.log(res)
      return res
    },
  }
})